import { render, staticRenderFns } from "./App.vue?vue&type=template&id=49b45c81&"
import script from "./_app.js?vue&type=script&lang=js&"
export * from "./_app.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports